/**
 * Validates an email address.
 * @param email - The email address to validate.
 * @returns An error message if the validation fails, otherwise an empty string.
 */
export const validateEmail = (email: string): string => {
  if (email.trim() === "") {
    return "Please enter your email address.";
  }

  if (!/\S+@\S+\.\S+/.test(email)) {
    return "Please enter a valid email address.";
  }

  return ""; // No errors
};

/**
 * Validates a username (email format).
 * @param username - The username to validate.
 * @returns An error message if the validation fails, otherwise an empty string.
 */
export const validateUsername = (username: string): string => {
  if (username.trim() === "") {
    return "Please enter your username.";
  }
  if (!/\S+@\S+\.\S+/.test(username)) {
    return "Please enter a valid email address.";
  }
  return ""; // No errors
};

/**
 * Validates a password.
 * @param password - The password to validate.
 * @returns An error message if the validation fails, otherwise an empty string.
 */
export const validatePassword = (password: string): string => {
  if (password.trim() === "") {
    return "Please enter your password.";
  }
  if (password.length < 6) {
    return "Password must be at least 6 characters long.";
  }
  if (!/[A-Z]/.test(password)) {
    return "Password must contain at least one uppercase character.";
  }
  if (!/[a-z]/.test(password)) {
    return "Password must contain at least one lowercase character.";
  }
  if (!/[0-9]/.test(password)) {
    return "Password must contain at least one digit.";
  }
  if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
    return "Password must contain at least one special character.";
  }

  return ""; // No errors
};

/**
 * Checks if passwords match.
 * @param password - The password.
 * @param confirmPassword - The confirmation password.
 * @returns An error message if they don't match, otherwise an empty string.
 */
export const validatePasswordMatch = (
  password: string,
  confirmPassword: string
): string => {
  if (password !== confirmPassword) {
    return "Passwords do not match.";
  }
  return ""; // No errors
};
